import { render, staticRenderFns } from "./MQF_Info_demo_lp.vue?vue&type=template&id=127b6308&"
import script from "./MQF_Info_demo_lp.vue?vue&type=script&lang=js&"
export * from "./MQF_Info_demo_lp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports